
<template>
  <div class="histogram-section">
    <div>
      <div class="section-title">Live image analysis</div>
      <div class="section-paragraph">
        The eye cannot always be trusted and especially in difficult lighting situations precise control is important.
        In Camoodoo you can show different image analysis tools to get an objective evaluation of the live view.
      </div>
    </div>
    <div class="section-paragraph images">
      <info-box caption="Luminance Histogram">
        <q-img class="image" src="images/histogram_gray.jpg" :ratio="16/9" contain></q-img>
      </info-box>
      <info-box caption="RGB Histogram">
        <q-img class="image" src="images/histogram_color.jpg" :ratio="16/9" contain></q-img>
      </info-box>
      <info-box caption="Waveform">
        <q-img class="image" src="images/histogram_wave.jpg" :ratio="16/9" contain></q-img>
      </info-box>
      <info-box caption="Vectorscope">
        <q-img class="image" src="images/histogram_vector.jpg" :ratio="16/9" contain></q-img>
      </info-box>
    </div>
  </div>
</template>

<script>
import InfoBox from "@/components/InfoBox.vue";
export default {
  components: {
    InfoBox
  }
};
</script>

<style scoped>
.histogram-section {
  display: grid;
  grid-template-columns: 1fr;
  align-items: center;
  justify-items: center;
  grid-gap: var(--content-margin);
  padding: var(--section-padding);
}

.images {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-auto-rows: 1fr;
  grid-gap: var(--content-margin);
  align-self: stretch;
  justify-self: center;
  margin-left: 10%;
  width: 90%;
  margin-right: 10%;
  max-width: 500pt;
}

.image {
  max-height: 200pt;
}
</style>
